module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABN0lEQVRYR+3WPW4CMRAF4Pd6zsEJ0tBRp0/6NKEOF0hygVCTJj0cICVUOQSXmciRjUbGP2MHFopdaSVYreZ9DGPvElc+eOV8HAEisgMwHwi0JfnosjTgB8BsIMA3yfsYMAFwNwSA5D7k3M4M9PxyEdn8tdH/nz01ujvgwx986HGoWhFdgCg8ZHYhmgGZ8G5EEyAKfwPgTnfoz02dMAPicJLvIiJ+CCkirwpkRpgAqXAXrAH+ezOiCsiFpwA9iCKgFJ4DtCKygFp4CdCCSAIs4TWAFXECEJE1gOewvNy053a3eAhT90Wr45PkQt+XAnwAeHFLqhRu6UAIUogVyWUR4AtPSR5q+7qlAwox14/hcL26DEuIFkCuzggYOzB2YOzAfzvw5d+Inmq75kU2ot7Q6rPgHIWtNX4Bj4nMIWmSqJIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.png
// module id = Uw9C
// module chunks = 34